import React, {useState} from 'react';

function SurveysSorter(props) {

    const sorters = [ {sortName: "Last modified", sortField: "LAST_MODIFIED"},
        {sortName: "Date created", sortField: "DATE_OF_CREATION"}, {sortName: "Respondents", sortField: "RESPONDENTS"}
    ]

    const [isSorterToggled, setIsSorterToggled] = useState(false);
    const [surveysSortOptions, setSurveysSortOptions] = useState(sorters);

    function onSurveysSorterClick(){
        setIsSorterToggled(!isSorterToggled);
    }

    function onSortOptionClick(index) {
        const optionField = surveysSortOptions[index].sortField;
        props.sortFunction(optionField);

        let surveysSortOptionsReordered = [...surveysSortOptions];
        surveysSortOptionsReordered.unshift(surveysSortOptionsReordered.splice(index, 1)[0]);
        setSurveysSortOptions(surveysSortOptionsReordered);
    }

    let sorterHtmlList = surveysSortOptions.map((option, index) => {
        const optionName = option.sortName;
        return (
            <li key={"surveys_sort_button_" + index}><a href="javascript:void(0)" onClick={() => {onSortOptionClick(index)}}>{optionName}</a></li>
        )
    });

    return (
        <div className="surveys__menu__filters__sort">
            <span>Sort By</span>
            <div className="surveys__menu__filters__sort__list" onClick={onSurveysSorterClick}>
                <span className="surveys__menu__filters__sort__list__placeholder" style={{opacity: (isSorterToggled ? 0: 1)}}>{surveysSortOptions[0].sortName}</span>
                <ul className="surveys__menu__filters__sort__list__ul" style={{display: (isSorterToggled ? "block": "none")}}>
                    { sorterHtmlList }
                </ul>
            </div>
        </div>
    );
}

export default SurveysSorter;